import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Button, IconButton, Typography } from "@/components/atoms";
import { getPhpHostUrl } from "@/helpers/apiHelpers";
import { useAppResetApi } from "@/redux/hooks";
import { clsx } from "@/utils";
import { ClientBookTripButton } from "./ClientBookTripButton";
import { ClientDrawerMenu } from "./ClientDrawerMenu";
import { ClientLogo } from "./ClientLogo";
import { useClientNavLinks } from "./ClientNavLinks";

export const ClientHeader = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const resetApi = useAppResetApi();
  const { logout } = useKindeAuth();
  const phpHostUrl = getPhpHostUrl();
  const clientNavLinks = useClientNavLinks();

  const handleLogout = async () => {
    resetApi();
    if (import.meta.env.MODE === "production") {
      window.location.href = `${phpHostUrl}/logout`;
    } else {
      await logout();
    }
  };

  return (
    <div className="z-40">
      <nav className="border-b border-neutral-mid-gray bg-neutral-surface-gray">
        {/* Desktop View */}
        <div className="hidden h-[72px] items-center px-8 lg:flex">
          <ClientLogo />

          {/* Nav Links */}
          <div className="ml-6 flex items-center gap-1">
            {clientNavLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.to}
                end={link.to === "/client"}
                className={({ isActive }) =>
                  clsx("relative px-4 py-6 transition-colors", {
                    "text-primary": isActive,
                    "text-neutral-dark-gray hover:text-neutral-black": !isActive,
                  })
                }
              >
                {({ isActive }) => (
                  <>
                    <Typography variant="action" className="font-medium">
                      {link.name}
                    </Typography>
                    {isActive && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />}
                  </>
                )}
              </NavLink>
            ))}
          </div>

          {/* Right Actions */}
          <div className="ml-auto flex items-center gap-3">
            <ClientBookTripButton />
            <Button variant="tertiary-light" size="sm" startIcon="LogoutCurve" onClick={handleLogout}>
              Logout
            </Button>
          </div>
        </div>

        {/* Tablet/Mobile View */}
        <div className="flex h-16 items-center justify-between px-5 lg:hidden">
          <ClientLogo />
          <IconButton iconName="HambergerMenu" variant="tertiary-light" iconSize="lg" onClick={() => setDrawerOpen(true)} />
        </div>
      </nav>

      <ClientDrawerMenu open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </div>
  );
};
